import styled from "@emotion/styled";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useTranslation } from "react-i18next";
import { Checkbox } from "src/components/Default/LekUI/Checkbox";

import { useGetConsultants } from "../../../hooks/useConsultants";
import Filter from "./DefaultFilters";

const FiltersBox = styled("div")`
  display: flex;
  flex-direction: column;
`;

export default function ConsultantsOptionsFilter(props) {
	const { data: consultants, isLoading } = useGetConsultants();
	const { t } = useTranslation();

	const keySelected = (key, id) => {
		return props.selectedData[key].some((sd) => sd.id === id);
	};

	const setSelected = (consultant) => {
		const { selectedData } = props;
		if (keySelected("consultants", consultant.id)) {
			props.setSelectedData({
				consultants: selectedData.consultants.filter(
					({ id }) => consultant.id !== id,
				),
			});
		} else {
			props.setSelectedData({
				consultants: [...selectedData.consultants, consultant],
			});
		}
	};

	const renderFilter = (consultant) => {
		return (
			<FormControlLabel
				label={consultant.name}
				control={
					<Checkbox
						checked={keySelected("consultants", consultant.id)}
						onChange={() => setSelected(consultant)}
					/>
				}
			/>
		);
	};

	const renderFilters = () => {
		return <FiltersBox>{consultants.map(renderFilter)}</FiltersBox>;
	};

	if (consultants && consultants.length === 0 && !isLoading) {
		return null;
	}

	return (
		<Filter
			{...props}
			title={t("filters.exams.consultants.title")}
			renderFilterDetails={renderFilters}
		/>
	);
}
